module.exports = __webpack_public_path__ + "fonts/sourcesansprobold.faee4ee7.woff";